import React from 'react';
import { FileCheck2Icon, LockKeyholeIcon, ShieldIcon, SproutIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AboutPageHero } from '../components/AboutPageHero';
const documents = [{
  icon: FileCheck2Icon,
  title: 'Permits & entry requirements',
  text: 'The Manaslu region requires a Restricted Area Permit, Manaslu Conservation Area Permit, and Annapurna Conservation Area Permit. We arrange the applicable permits after receiving the documents required by Nepal’s authorities.'
}, {
  icon: LockKeyholeIcon,
  title: 'Privacy & personal information',
  text: 'We use your information only to plan and operate your journey, meet permit obligations, and communicate with you. We do not sell personal data, and access is limited to partners who need it for your trip.'
}, {
  icon: ShieldIcon,
  title: 'Insurance & emergency support',
  text: 'Each traveller must hold medical and evacuation insurance suitable for high-altitude trekking. We keep policy and emergency-contact details solely to support appropriate decisions if a medical situation arises.'
}, {
  icon: SproutIcon,
  title: 'Responsible travel policy',
  text: 'Our operating principles include local hiring, fair porter practices, reduced single-use plastics, waste carried out where practical, and respect for cultural sites, wildlife, and water sources.'
}];
export function LegalDocumentsPage() {
  return <main className="w-full bg-[#f7f4ed] text-[#233a32]" data-id="element-599" data-mp="3olbhxg3tdk3g">
      <AboutPageHero eyebrow="Legal documents & policies" title="The details that protect the journey." description="A clear overview of the permits, policies, and protections that support safe, responsible trekking in Manaslu." imageUrl="https://images.unsplash.com/photo-1454496522488-7a8e488e8606?auto=format&fit=crop&w=2000&q=85" data-id="element-600" data-mp="3teo6jq8htqw7" />
      <section className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-601" data-mp="3anwnty2m8o55">
        <div className="grid gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-602" data-mp="3ap7qfukbrpuo">
          <h2 className="font-serif text-4xl leading-tight sm:text-5xl" data-id="element-603" data-mp="2rk2ywd4xckh5">
            Travel well informed.
          </h2>
          <p className="text-base leading-8 text-[#53645b]" data-id="element-604" data-mp="2mq72hf4b75o3">
            Before departure, we provide the trip-specific documentation needed
            for your booking. This page explains the framework we use to keep
            your information protected, your travel compliant, and our presence
            in the Himalaya responsible.
          </p>
        </div>
        <div className="mt-16 grid gap-8 md:grid-cols-2" data-id="element-605" data-mp="35j2nxlwcn1du">
          {documents.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="border-t border-[#a98b50] pt-6" data-id="element-606" data-mp="30lj8iinx0ikb">
              <Icon className="h-5 w-5 text-[#9a7b3e]" aria-hidden="true" data-id="element-607" data-mp="2vjtwazoyhyun" />
              <h3 className="mt-5 font-serif text-2xl" data-id="element-608" data-mp="1p5chi8hrc111">{title}</h3>
              <p className="mt-3 text-sm leading-7 text-[#53645b]" data-id="element-609" data-mp="1k56oanvua6gu">{text}</p>
            </article>)}
        </div>
      </section>
      <section className="border-y border-[#d9d0bf] bg-[#efe9dc] px-6 py-14" data-id="element-610" data-mp="3vtl6toemlouh">
        <div className="mx-auto max-w-5xl text-center" data-id="element-611" data-mp="4lpi8mlpy5es">
          <h2 className="font-serif text-3xl" data-id="element-612" data-mp="4k61yw02bud0">
            Questions about your documents?
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-[#53645b]" data-id="element-613" data-mp="9jin9cbactdh">
            We are happy to clarify a permit, policy, or insurance requirement
            before you reserve.
          </p>
          <Link to="/contact" className="mt-7 inline-flex border-b border-[#9a7b3e] pb-2 text-sm font-semibold uppercase tracking-[0.16em] text-[#233a32] hover:text-[#9a7b3e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4" data-id="element-614" data-mp="jdho87zmi73u">
            Speak with our team
          </Link>
        </div>
      </section>
    </main>;
}